import React, { Component } from 'react';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import cookies from 'next-cookies';

export default class index extends Component {
    constructor(props) {
        super(props); 
        this.state = {
            isClosed : this.props.isChecked == "true" ? true : false
        }
    }
    
    closeHeaderTag = () => {
        this.setState({ isClosed : true })
        document.cookie = `isChecked=` + true;
    }

    render() { 
        return (
            <div>
                <div className={this.state.isClosed ? "header-tag-btn desktop tag-closed" : "desktop header-tag-btn"}>
                Ask Our Executive for No Cost EMI Offer
                <span className="pl-3 pr-2"><img src={`${publicRuntimeConfig.staticFolder}/images/close.png`} alt="Tag close" className="tag-close" onClick={this.closeHeaderTag} /></span>
            </div>
            <div className={this.state.isClosed ? "header-tag-btn mobile tag-closed" : "mobile header-tag-btn"}>
            Ask Our Executive for No Cost EMI Offer
                <span className="pl-3 pr-2"><img src={`${publicRuntimeConfig.staticFolder}/images/close.png`} alt="Tag close" className="tag-close" onClick={this.closeHeaderTag} /></span>
            </div>
            </div>
        )
    }
}
